module.exports = __webpack_public_path__ + "img/progress_051.f9f8bba2.png";